import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Typography,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

const ShopManagement = () => {
  const [shops, setShops] = useState([]);
  const [filteredShops, setFilteredShops] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedRouteId, setSelectedRouteId] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [routes, setRoutes] = useState([]);
  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    address: "",
    contactInfo: "",
    email: "",
    routeId: "",
  });

  useEffect(() => {
    fetchShops();
    fetchRoutes();
  }, []);
  const fetchRoutes = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/routes`);
      if (response.ok) {
        const data = await response.json();
        setRoutes(data);
      } else {
        console.log("failed to fetch routes");
      }
    } catch (e) {
      console.log("Error fetching routes");
    }
  };

  const fetchShops = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/shops`);
      if (response.ok) {
        const data = await response.json();
        setShops(data);
      } else {
        console.log("failed to fetch shops");
      }
    } catch (e) {
      console.log("Error fetching Shops", e);
    }
  };
  useEffect(() => {
    setFilteredShops(
      shops?.filter(
        (shop) =>
          shop.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          shop.address.toLowerCase().includes(searchQuery.toLowerCase()) ||
          shop.contactInfo.toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  }, [shops, searchQuery]);

  const handleOpen = (shop) => {
    console.log("shop is ", shop);
    if (shop) {
      setIsEditing(true);
      setFormData({
        _id: shop._id,
        name: shop.name,
        address: shop.address,
        contactInfo: shop.contactInfo,
        email: shop.email,
        routeId: shop.routeId.routeName ? shop.routeId._id : "",
      });
    } else {
      setIsEditing(false);
      setFormData({
        id: 0,
        name: "",
        address: "",
        contactInfo: "",
        routeId: "",
      });
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleDeleteCancel = () => {
    setConfirmOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const endPoint = isEditing
      ? `${process.env.REACT_APP_API_URL}/shop/${formData._id}`
      : `${process.env.REACT_APP_API_URL}/shop`;
    const Options = {
      method: isEditing ? "Put" : "Post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    };
    try {
      const response = await fetch(endPoint, Options);
      if (response.ok) {
        const newShop = await response.json();

        if (isEditing) {
          setShops((prev) =>
            prev.map((shop) =>
              shop._id === formData._id ? { ...newShop } : shop
            )
          );
        } else {
          setShops((prev) => [...prev, newShop]);
        }
        fetchShops();
        fetchRoutes();
        handleClose();
      }
    } catch (error) {
      console.log("failed to submit shop", error);
    }
  };
  const handleDeleteConfirm = (id) => {
    console.log("id of shop is ", id);
    setSelectedRouteId(id);
    setConfirmOpen(true);
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/shop/${selectedRouteId}`,
        {
          method: "Delete",
        }
      );
      if (response.ok) {
        // setShops((preShop) => {
        //   preShop.filter((shop) => shop.id !== selectedRouteId);
        // });
        setConfirmOpen(false);
        setSelectedRouteId(null);
        fetchShops();
        fetchRoutes();
      } else {
        console.log("failed to delete shop");
      }
    } catch (error) {
      console.error("Error deleting the shop:", error);
    }
  };
  const shopPagination = filteredShops?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box padding={3}>
      <h2>Shops Management</h2>
      <Box display="flex" justifyContent="space-between" marginBottom={2}>
        <Box sx={{ width: "50%" }}>
          <TextField
            label="Search Shops"
            variant="outlined"
            fullWidth
            margin="normal"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search by name, address, or contact info"
          />
        </Box>

        <Button
          variant="contained"
          color="primary"
          onClick={() => handleOpen()}
          sx={{ height: 50 }}
        >
          Add Shop
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#1976d2" }}>
            <TableRow>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Name
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Address
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Contact Info
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Email
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                RouteName
              </TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {shopPagination?.map((shop) => (
              <TableRow key={shop.id}>
                <TableCell>{shop.name}</TableCell>
                <TableCell>
                  {" "}
                  <Tooltip title={shop.address}>
                    <Typography
                      noWrap
                      sx={{
                        maxWidth: 150,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {shop.address}
                    </Typography>
                  </Tooltip>
                </TableCell>
                <TableCell>{shop.contactInfo}</TableCell>
                <TableCell>{shop?.email}</TableCell>
                <TableCell>
                  <Tooltip title={shop.routeId?.routeName}>
                    <Typography
                      noWrap
                      sx={{
                        maxWidth: 150,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {shop.routeId?.routeName}
                    </Typography>
                  </Tooltip>
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => handleOpen(shop)}
                    style={{ marginRight: "10px" }}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => handleDeleteConfirm(shop._id)}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{isEditing ? "Edit Shop" : "Add Shop"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            name="name"
            label="Name"
            type="text"
            fullWidth
            value={formData.name}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            name="address"
            label="Address"
            type="text"
            fullWidth
            value={formData.address}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            name="contactInfo"
            label="Contact Info"
            type="text"
            fullWidth
            value={formData.contactInfo}
            onChange={handleChange}
          />
          <TextField
            margin="dense"
            name="email"
            label="Email"
            type="text"
            fullWidth
            value={formData.email}
            onChange={handleChange}
          />
          <Box sx={{ minWidth: 120, marginTop: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Routes</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Routes"
                value={formData.routeId}
                name="routeId"
                onChange={handleChange}
              >
                {routes.map((item) => (
                  <MenuItem key={item._id} value={item._id}>
                    {item.routeName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary">
            {isEditing ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={confirmOpen} onClose={handleDeleteCancel}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this route?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="primary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <TablePagination
        component="div"
        count={shops?.length || 0}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default ShopManagement;
